import React, {lazy, Suspense} from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AppRoute, RoutePath} from "./RoutingModels";
import PublicLayout from "@components/Layout/Public/PublicLayout";
import PrivateLayout from "@components/Layout/Private/PrivateLayout";
import ProtectedRoute from "@router/ProtectedRoute";
import I18nTestPage from "@pages/Debug/i18nPage/I18nTestPage";
import FormTestPage from "@pages/Debug/FormPage/FormTestPage";
import RouteEffects from "@router/RouteEffects";
import {RouteChangeTracker} from "@router/RouteChangeTracker";
import WelcomePage from "@pages/Welcome/WelcomePage";
import SsoPage from "@pages/Sso/SsoPage";
import {OnboardPage} from "@pages/Onboard/OnboardPage";
import HomePage from "@pages/Home/HomePage";
import InvoicePage from "@pages/Invoice/InvoicePage";
import CatalogPage from "@pages/Catalog/CatalogPage";
import ProductPage from "@pages/Product/ProductPage";
import ContactPage from "@pages/Contact/ContactPage";
import HowToPage from "@pages/HowTo/HowToPage";
import FaqsPage from "@pages/Faqs/FaqsPage";
import BoostsPage from "@pages/Boosts/BoostsPage";
import ContextualLayoutRoute from "@router/ContextualLayoutRoute";
import WebviewTestPage from "@pages/Debug/WebviewPage/WebviewTestPage";
import GtmTestPage from "@pages/Debug/GtmPage/GtmTestPage";

const DebugPage = lazy(() => import("@pages/Debug/DebugPage/DebugPage"));
const CookiePage = lazy(() => import("@pages/Cookie/CookiePage"));
const ProfilePage = lazy(() => import("@pages/Profile/ProfilePage"));
const HistoryRewardsPage = lazy(() => import("@pages/History/HistoryRewards/HistoryRewardsPage"));
const HistoryPointsPage = lazy(() => import("@pages/History/HistoryPoints/HistoryPointsPage"));
const HistoryInvoicesPage = lazy(() => import("@pages/History/HistoryInvoices/HistoryInvoicesPage"));
const OpsPage = lazy(() => import("@pages/Ops/OpsPage"));

export default function AppRouter() {
    return (
        <BrowserRouter>
            <Suspense fallback={null}>

                <RouteEffects/>

                <RouteChangeTracker/>

                <Routes>

                    {/* Public */}
                    <Route element={<PublicLayout/>}>
                        <Route path={RoutePath[AppRoute.WELCOME]} element={<WelcomePage/>}/>
                        <Route path={RoutePath[AppRoute.SSO]} element={<SsoPage/>}/>
                        <Route path={"/auth/login"} element={<SsoPage/>}/>
                        <Route path={"/auth/logout"} element={<SsoPage/>}/>
                        <Route path={RoutePath[AppRoute.ON_BOARD]} element={<OnboardPage/>}/>
                    </Route>

                    {/* Hybrid */}
                    <Route element={<ContextualLayoutRoute/>}>
                        <Route path={RoutePath[AppRoute.OPS]} element={<OpsPage/>}/>
                        <Route path={RoutePath[AppRoute.ERROR_404]} element={<OpsPage pageState={{reason: "404"}}/>}/>
                        <Route path={RoutePath[AppRoute.COOKIE_POLICY]} element={<CookiePage/>}/>

                        <Route path="/i18n-test" element={<I18nTestPage/>}/>
                        <Route path="/form-test" element={<FormTestPage/>}/>
                        <Route path="/webview-test" element={<WebviewTestPage/>}/>
                        <Route path="/gtm-test" element={<GtmTestPage/>}/>
                    </Route>

                    {/* Private */}
                    <Route element={<ProtectedRoute><PrivateLayout/></ProtectedRoute>}>
                        <Route path={RoutePath[AppRoute.HOME]} element={<HomePage/>}/>
                        <Route path={RoutePath[AppRoute.INVOICE]} element={<InvoicePage/>}/>
                        <Route path={RoutePath[AppRoute.CATALOG]} element={<CatalogPage/>}/>
                        <Route path={RoutePath[AppRoute.PRODUCT]} element={<ProductPage/>}/>
                        <Route path={RoutePath[AppRoute.BOOSTS]} element={<BoostsPage/>}/>
                        <Route path={RoutePath[AppRoute.CONTACTS]} element={<ContactPage/>}/>
                        <Route path={RoutePath[AppRoute.HOW_TO]} element={<HowToPage/>}/>
                        <Route path={RoutePath[AppRoute.FAQS]} element={<FaqsPage/>}/>
                        <Route path={RoutePath[AppRoute.PROFILE]} element={<ProfilePage/>}/>
                        <Route path={RoutePath[AppRoute.REWARDS_HISTORY]} element={<HistoryRewardsPage/>}/>
                        <Route path={RoutePath[AppRoute.POINTS_HISTORY]} element={<HistoryPointsPage/>}/>
                        <Route path={RoutePath[AppRoute.INVOICES_HISTORY]} element={<HistoryInvoicesPage/>}/>
                    </Route>

                    <Route path={RoutePath[AppRoute.DEBUG]} element={<DebugPage/>}/>

                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
